module.exports = __webpack_public_path__ + "static/media/logo_text.e1ec1a36.png";